import {types} from './types';

const initialState = {
    list: [],
    view: {},
    event: {
        count: 1,
        list: []
    },
    gamer: {
        list: [],
        count: 1
    },
    bet: {
        sumBet: 0,
        countBet: 0,
        sumWin: 0
    },
    detalization: {
        count: 0,
        sumDeposit: 0,
        sumWithdrawal: 0
    },
    gamer_information: {
        count_gamer: 0,
    },
    history: {
        list: [],
        page: 0
    }
}

export function groupsReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GROUPS:
            return { ...state, list: action.payload};
        case types.SET_GROUPS_VIEW:
            return { ...state, view: action.payload};
        case types.SET_GET_EVENT_HISTORY:
            return { ...state, event: action.payload};
        case types.SET_GAMER_LIST:
            return { ...state, gamer: action.payload};
        case types.SET_BET:
            return { ...state, bet: action.payload};
        case types.SET_OPERATOR_DETALIZATION:
            return { ...state, detalization: action.payload}
        case types.SET_COUNT_GAMER:
            return { ...state, gamer_information: action.payload}
        case types.SET_LIST_CREDIT_HISTORY:
            return { ...state, history: action.payload}
        default:
            return state
    }
}